// Enhanced partner logos with real company names and better styling
export const PARTNER_LOGOS = {
  enterprise: [
    {
      name: "SAP",
      category: "ERP & Enterprise Software",
      url: "https://www.sap.com",
      description: "Enterprise Resource Planning"
    },
    {
      name: "Oracle",
      category: "Database & Cloud",
      url: "https://www.oracle.com",
      description: "Enterprise Database Solutions"
    },
    {
      name: "Salesforce",
      category: "CRM",
      url: "https://www.salesforce.com",
      description: "Customer Relationship Management"
    },
    {
      name: "Microsoft",
      category: "Cloud & Productivity",
      url: "https://www.microsoft.com",
      description: "Azure, Dynamics 365, Office 365"
    },
    {
      name: "NetSuite",
      category: "Cloud ERP",
      url: "https://www.netsuite.com",
      description: "Cloud Enterprise Software"
    },
    {
      name: "ServiceNow",
      category: "IT Service Management",
      url: "https://www.servicenow.com",
      description: "Digital Workflow Platform"
    },
    {
      name: "Workday",
      category: "HR & Finance",
      url: "https://www.workday.com",
      description: "Human Capital Management"
    },
    {
      name: "AWS",
      category: "Cloud Infrastructure",
      url: "https://aws.amazon.com",
      description: "Amazon Web Services"
    }
  ],
  lowCode: [
    {
      name: "OutSystems",
      category: "Low-Code Platform",
      url: "https://www.outsystems.com",
      description: "Enterprise Low-Code Development"
    },
    {
      name: "Mendix",
      category: "Low-Code Platform",
      url: "https://www.mendix.com",
      description: "Rapid Application Development"
    },
    {
      name: "Microsoft Power Platform",
      category: "Low-Code Suite",
      url: "https://powerplatform.microsoft.com",
      description: "Power Apps, Power Automate"
    },
    {
      name: "Appian",
      category: "Process Automation",
      url: "https://www.appian.com",
      description: "Low-Code Automation Platform"
    },
    {
      name: "Bubble",
      category: "No-Code Platform",
      url: "https://bubble.io",
      description: "Visual Programming Platform"
    },
    {
      name: "Retool",
      category: "Internal Tools",
      url: "https://retool.com",
      description: "Build Internal Tools Fast"
    }
  ],
  cloud: [
    {
      name: "AWS",
      category: "Cloud Provider",
      description: "Amazon Web Services"
    },
    {
      name: "Microsoft Azure",
      category: "Cloud Provider",
      description: "Microsoft Cloud Platform"
    },
    {
      name: "Google Cloud",
      category: "Cloud Provider",
      description: "Google Cloud Platform"
    },
    {
      name: "IBM Cloud",
      category: "Cloud Provider",
      description: "IBM Cloud Services"
    }
  ],
  integration: [
    {
      name: "MuleSoft",
      category: "Integration Platform",
      description: "API-Led Integration"
    },
    {
      name: "Dell Boomi",
      category: "Integration Platform",
      description: "Cloud Integration"
    },
    {
      name: "Informatica",
      category: "Data Integration",
      description: "Enterprise Data Management"
    },
    {
      name: "Talend",
      category: "Data Integration",
      description: "Open Source Integration"
    }
  ]
};

export const CERTIFICATIONS = [
  {
    name: "ISO 27001",
    description: "Information Security Management",
    icon: "Shield"
  },
  {
    name: "SOC 2 Type II",
    description: "Security & Compliance",
    icon: "Lock"
  },
  {
    name: "AWS Advanced Partner",
    description: "Cloud Excellence",
    icon: "Cloud"
  },
  {
    name: "Microsoft Gold Partner",
    description: "Enterprise Solutions",
    icon: "Award"
  },
  {
    name: "Salesforce Partner",
    description: "CRM Expertise",
    icon: "Star"
  }
];

export const TEAM_STATS = [
  {
    stat: "95%",
    label: "Hold Advanced Certifications",
    icon: "GraduationCap"
  },
  {
    stat: "12+ years",
    label: "Average Industry Experience",
    icon: "Briefcase"
  },
  {
    stat: "200+",
    label: "Expert Consultants",
    icon: "Users"
  },
  {
    stat: "50+",
    label: "Technology Specialists",
    icon: "Cpu"
  }
];

export const BACKGROUND_IMAGES = {
  hero: "https://images.unsplash.com/photo-1644088379091-d574269d422f",
  aiTech: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4",
  abstract1: "https://images.unsplash.com/photo-1689443111384-1cf214df988a",
  abstract2: "https://images.unsplash.com/photo-1658959305360-b942374cb042",
  office1: "https://images.unsplash.com/photo-1762341116197-fb94a4f37173",
  office2: "https://images.unsplash.com/photo-1770777843445-2a1621b1201d"
};

// Real client logos (Fortune 500 companies we've worked with - examples)
export const CLIENT_LOGOS = [
  { name: "Fortune 500 Manufacturing", industry: "Manufacturing" },
  { name: "Global Bank Corp", industry: "Financial Services" },
  { name: "Tech Retail Group", industry: "Retail" },
  { name: "HealthCare Systems Inc", industry: "Healthcare" },
  { name: "Logistics Global Ltd", industry: "Logistics" },
  { name: "Energy Corporation", industry: "Energy" }
];
